import { Injectable } from '@angular/core';
import { GetPathwayCardsGQL, PathwayCard } from '@cpd-app/generated';
import { filter, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PathwayCardsService {
  constructor(private getPathwayCardsGQL: GetPathwayCardsGQL) {}

  getPathwaysByCategory(): Observable<PathwayCard[]> {
    return this.getPathwayCardsGQL.fetch().pipe(
      // The same guard the occupation cards carry, for the same reason. Apollo
      // deduplicates identical in-flight queries and hands one of two
      // subscribers a frame with `data` undefined, and dereferencing it threw
      // a TypeError that the effect turned into loadPathwayCardsError, so the
      // band silently emptied. Dropping the frame makes that subscriber wait
      // for the real one instead.
      filter((result) => !!result?.data),
      map((result) => {
        // `getPathwayCards` is [PathwayCard] and nullable in the schema, so a
        // null list would reach Array.from and throw as well.
        const pathwayCards = result?.data?.getPathwayCards ?? [];

        return Array.from(pathwayCards);
      })
    );
  }
}
